import { __assign } from "tslib";
import { useState } from 'react';
// constants
import { FEATURE_MODES, LOCAL_MODE_KEY } from '../../../constants/ab-testing.constants';
export function useABTestingAPI(appKey, defaultFeatures) {
    var _a = useState(defaultFeatures || {}), features = _a[0], setFeatures = _a[1];
    var _b = useState(appKey === LOCAL_MODE_KEY), isLocal = _b[0], setIsLocal = _b[1];
    function activateABTesting(feature, variant) {
        var _a;
        if (variant === void 0) { variant = FEATURE_MODES.ON; }
        setFeatures(__assign(__assign({}, features), (_a = {}, _a[feature] = variant, _a)));
        setIsLocal(true);
    }
    function deactivateABTesting(feature) {
        var _a;
        setFeatures(__assign(__assign({}, features), (_a = {}, _a[feature] = FEATURE_MODES.OFF, _a)));
        setIsLocal(true);
    }
    function toggleLocalMode(isLocalMode) {
        setIsLocal(isLocalMode);
    }
    function getActiveABTesting() {
        // TODO - get active ab testing for live mode
        return Object.keys(features).filter(function (feature) { return features[feature] !== FEATURE_MODES.OFF; });
    }
    var globalObj = typeof window !== 'undefined' ? window : global;
    Object.assign(globalObj, {
        activateABTesting: activateABTesting,
        deactivateABTesting: deactivateABTesting,
        toggleLocalMode: toggleLocalMode,
        getActiveABTesting: getActiveABTesting
    });
    return { isLocal: isLocal, features: features };
}
//# sourceMappingURL=useABTestingAPI.js.map